import { render } from "./navBar.vue?vue&type=template&id=20baa807&scoped=true"
import script from "./navBar.vue?vue&type=script&lang=js"
export * from "./navBar.vue?vue&type=script&lang=js"

import "./navBar.vue?vue&type=style&index=0&id=20baa807&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/testportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20baa807"]])

export default __exports__